// @ts-check
import { createCrudProp } from '../utils/crud-prop'
import { createSelector } from '../utils/selector-utils'

const prop = createCrudProp({
  rootKey: 'laDilutions',
  idPrefix: 'customla',
  requiredProps: ['variantId', 'percent'],
  mapFn: entry => ({
    ...entry,
    percent: Number(entry.percent),
  }),
})

/**
 * @param {{
 *   variantId: string
 *   percent: number
 * }} localDilution
 * @param {string} [preGeneratedId]
 * @returns {any} The changes to apply to the case.
 */
export const actionAddLocalDilutionRaw = prop.actionAdd

/**
 * @param {string} customVariantId
 * @returns {any} The changes to apply to the case.
 */
export const actionRemoveLocalDilutionRaw = prop.actionRemove

/**
 * @type {CaseSelector<{
 *   [dilutionId: string]: LocalDilutionEntry
 * }>}
 */
// @ts-ignore
export const selectLocalDilutionsById = prop.selectById

/**
 * @type {CaseSelector<{
 *   [drugVariantId: string]: LocalDilutionEntry[]
 * }>}
 */
export const selectLocalDilutionsByBaseDrugId = createSelector(
  selectLocalDilutionsById,
  /**
   * @param {{
   *   [dilutionId: string]: LocalDilutionEntry
   * }} byId
   */
  byId => {
    /** @type {{ [drugVariantId: string]: LocalDilutionEntry[] }} */
    const result = {}
    for (const key in byId) {
      const dilution = byId[key]
      if (!result[dilution.variantId]) {
        result[dilution.variantId] = []
      }
      result[dilution.variantId].push(dilution)
    }
    return result
  }
)
